import { Component } from '@angular/core';

@Component({
  imports: [],
  selector: 'ui-dropdown-option',
  templateUrl: './dropdown-option.html',
})
export class DropdownOption {}
